import React, { useEffect } from 'react';
import { WhatsNewPageView, WhatsNewPageViewProps } from './WhatsNewPage.view';
import {
  GetUnreadSiteNewsDocument,
  GetUnreadSiteNewsQuery,
  useGetAllSiteNewsQuery,
  useGetUnreadSiteNewsLazyQuery,
  useUpdateLastReadSiteNewsMutation
} from '../../../models/graphql';
import { useApolloClient } from '@apollo/client';

export type WhatsNewPageControllerProps = {
  // extend your WhatsNewPageViewProps
};

export const WhatsNewPageController = (props: WhatsNewPageControllerProps): JSX.Element => {
  const { cache } = useApolloClient();
  const { data, loading, error } = useGetAllSiteNewsQuery();
  const [updateLastReadSiteNewsFn] = useUpdateLastReadSiteNewsMutation();
  const [getUnreadSiteNews] = useGetUnreadSiteNewsLazyQuery();

  useEffect(() => {
    if (data && data.allSiteNews.length) {
      const newsIds = data.allSiteNews.map(item => +item.id);
      const latesId = Math.max(...newsIds);
      if (latesId) {
        updateLastReadSiteNewsFn({ variables: { siteNewsId: `${latesId}` } }).then(result => {
          if (result) {
            const latestNews = cache.readQuery<GetUnreadSiteNewsQuery>({
              query: GetUnreadSiteNewsDocument
            });
            if (latestNews) {
              cache.writeQuery({
                query: GetUnreadSiteNewsDocument,
                data: {
                  unreadSiteNews: []
                }
              });
            }
          }
        });
      }
    }
  }, [cache, data, getUnreadSiteNews, updateLastReadSiteNewsFn]);

  // Put All your methods and logic here
  const viewProps: WhatsNewPageViewProps = {
    ...props,
    error,
    loading,
    data,
    title: `What's new`
  };
  return <WhatsNewPageView {...viewProps} />;
};
